export enum CollectionStatusEnum {
  Active = 'active',
  Inactive = 'inactive'
}
